import { createFileRoute } from '@tanstack/react-router'

import { InboundMessagesScreen } from './-components/inbound-messages-screen.tsx'

export const Route = createFileRoute('/cs-tools/inbound-messages')({
  component: InboundMessagesScreen
})
